import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import { Header } from './Header';
import { Footer } from './Footer';
import { useLanguage } from '../contexts/LanguageContext';

const TEAM_MEMBERS = [
  { name: 'Paul', photo: '/PaulImage.jpeg', linkedin: 'https://www.linkedin.com/in/paul-schneider-3ba644267?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Paul', photo: '/PeopleImages/PaulKleiberImage.jpeg', linkedin: 'https://www.linkedin.com/in/paul-kleiber-86a87a313?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Fabienne', photo: '/PeopleImages/FabieneImage.jpeg', linkedin: 'https://www.linkedin.com/in/fabienne-reimers-3416a03a0?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Daniel', photo: '/PeopleImages/Daniel.jpeg', linkedin: 'https://www.linkedin.com/in/daniel-gerber-25b4b7323?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Anesa', photo: '/PeopleImages/AnesaImage.jpeg', linkedin: 'https://www.linkedin.com/in/anesa-hasanovic-02aa34297?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Emilia', photo: '/PeopleImages/EmiliaImage.jpeg', linkedin: 'https://www.linkedin.com/in/emilia-rau-132b03295?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Julia', photo: '/PeopleImages/JuliaImage.jpeg', linkedin: 'https://www.linkedin.com/in/julia-schikorra-911048278?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Marlene', photo: '/PeopleImages/MarleneImage.jpeg', linkedin: 'https://www.linkedin.com/in/marlenedoekel?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Joris', photo: '/PeopleImages/JorisImage.jpeg', linkedin: 'https://www.linkedin.com/in/joris-schleer-6a6025324?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Marvin', photo: '/PeopleImages/MarvinImage.jpeg', linkedin: 'https://www.linkedin.com/in/marvin-zaiss-b30b09357?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Daniel', photo: '/PeopleImages/DanielCremerImage.jpeg', linkedin: 'https://www.linkedin.com/in/daniel-c-0b650436b?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Emma', photo: '/PeopleImages/EmmaImage.jpeg', linkedin: 'https://www.linkedin.com/in/emma-loewenhaupt-ba7837307?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Raissa', photo: '/PeopleImages/Raissa.jpeg' },
  { name: 'Kilian', photo: '/PeopleImages/KilianImage.jpeg', linkedin: 'https://www.linkedin.com/in/kilian-rao-880962338?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
  { name: 'Rico', photo: '/PeopleImages/RicoImage.jpeg' },
  { name: 'Henrik', photo: '/PeopleImages/HenrikImage.jpeg' },
  { name: 'Marc', photo: '/PeopleImages/MarcTrösser.jpeg' },
];

export const Team = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-28 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="text-ngbc-primary hover:text-ngbc-accent font-medium mb-8 flex items-center gap-1"
          >
            ← {t('team.teamZurueck')}
          </button>
          <h1 className="text-4xl font-bold text-neutral-900 mb-2">
            {t('team.orgTeamTitle')}
          </h1>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-6 gap-y-10">
            {TEAM_MEMBERS.map((member, idx) => (
              <article key={idx} className="text-left">
                <div className="w-full aspect-[3/4] bg-neutral-100 overflow-hidden">
                  {member.photo ? (
                    <img
                      src={member.photo}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-neutral-200 flex items-center justify-center">
                      <span className="text-neutral-400 text-3xl font-bold">
                        {member.name
                          .split(' ')
                          .map((n) => n[0])
                          .join('')}
                      </span>
                    </div>
                  )}
                </div>
                {member.linkedin ? (
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-3 inline-flex items-center gap-1.5 font-bold text-neutral-900 text-base leading-snug hover:text-ngbc-accent transition-colors group"
                  >
                    {member.name}
                    <Linkedin className="w-4 h-4 text-[#0A66C2] opacity-70 group-hover:opacity-100 transition-opacity" />
                  </a>
                ) : (
                  <p className="mt-3 font-bold text-neutral-900 text-base leading-snug">
                    {member.name}
                  </p>
                )}
              </article>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
